/* Alamina Glass — theme behaviour. No dependencies. */
(() => {
  const T = window.theme || { routes: {}, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- announcement rotator ---------- */
  $$('[data-rotator]').forEach((wrap) => {
    const items = $$('.announcement__text', wrap);
    if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    const wide = matchMedia('(min-width: 990px)');
    setInterval(() => { if (wide.matches) return; items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4500);
  });

  /* ---------- mobile menu: position under the header, close others ---------- */
  const menu = $('[data-menu-drawer]');
  if (menu) {
    menu.addEventListener('toggle', () => {
      const header = $('[data-header]');
      if (header) document.documentElement.style.setProperty('--menu-top', header.getBoundingClientRect().bottom + 'px');
      document.body.classList.toggle('drawer-open', menu.open);
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('details[open]').forEach((d) => { if (d.matches('.menu-drawer, .header-search, .facets__drawer')) d.open = false; });
    closeCart();
  });
  document.addEventListener('click', (e) => {
    $$('.header-search[open], .facets__drawer[open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
  });
  $$('.header-search').forEach((d) => d.addEventListener('toggle', () => { if (d.open) { const i = $('input[type="search"]', d); i && i.focus(); } }));

  /* ---------- auto-submit (sort select, facet checkboxes, cart qty without JS drawer) ---------- */
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (el.matches('[data-auto-submit]') || el.closest('[data-facets] .facets__group input[type="checkbox"]')) el.form && el.form.submit();
  });

  /* ---------- cart drawer ---------- */
  const drawer = () => $('[data-cart-drawer]');
  let lastFocus = null;
  function openCart() {
    const d = drawer(); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const panel = $('.drawer__panel', d); panel && panel.focus();
  }
  function closeCart() {
    const d = drawer(); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  function renderDrawer(html) {
    if (!html) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
    const d = drawer(); if (!fresh || !d) return;
    const wasOpen = d.classList.contains('is-open');
    d.innerHTML = fresh.innerHTML;
    if (wasOpen) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); }
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
  }
  async function refreshCart(open) {
    const [cartRes, secRes] = await Promise.all([
      fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } }),
      fetch(T.routes.cart + '?section_id=cart-drawer')
    ]);
    const cart = await cartRes.json();
    setCount(cart.item_count);
    renderDrawer(await secRes.text());
    if (open) openCart();
    return cart;
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]') && drawer() && window.theme.cartType !== 'page') { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cart-close]')) closeCart();
  });

  async function changeLine(line, quantity) {
    const d = drawer(); d && d.classList.add('is-busy');
    const res = await fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: 'cart-drawer' })
    });
    const data = await res.json();
    if (data.sections) renderDrawer(data.sections['cart-drawer']);
    setCount(data.item_count);
    d && d.classList.remove('is-busy');
  }
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-change]');
    if (step) {
      const wrap = step.closest('[data-line]');
      const current = parseInt($('.qty__value', wrap).textContent, 10) || 0;
      changeLine(parseInt(wrap.dataset.line, 10), Math.max(0, current + parseInt(step.dataset.qtyChange, 10)));
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) changeLine(parseInt(rm.dataset.lineRemove, 10), 0);

    const qs = e.target.closest('[data-qty-step]');
    if (qs) {
      const input = $('input[name="quantity"]', qs.closest('.qty'));
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(qs.dataset.qtyStep, 10));
    }
  });

  /* ---------- add to cart (product page + product cards) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (window.theme.cartType === 'page') return; // normal submit → cart page
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]') || document.querySelector(`[form="${form.id}"]`);
    const err = form.querySelector('[data-form-error]');
    const label = btn ? btn.textContent : '';
    if (btn) btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);
      const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      const cart = await (await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })).json();
      setCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      if (btn) { btn.classList.add('is-added'); btn.textContent = T.strings.added; setTimeout(() => { btn.classList.remove('is-added'); btn.textContent = label; }, 1600); }
      openCart();
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; }
      else if (btn) { btn.textContent = ex.message; setTimeout(() => (btn.textContent = label), 2500); }
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  });

  /* ---------- product page: variants, gallery, sticky bar ---------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('[data-variants]', root);
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const picker = $('[data-variant-picker]', root);
    const rail = $('[data-gallery]', root);
    const thumbs = $$('[data-thumb]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-button]', root);
    const sticky = $('[data-sticky-buy]', root);
    const stickyBtn = $('[data-sticky-button]', root);
    const stickyPrice = $('[data-sticky-price]', root);

    const showMedia = (id) => {
      const slide = rail && rail.querySelector(`[data-media-id="${id}"]`);
      if (slide) rail.scrollTo({ left: slide.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumb)));
    if (rail && thumbs.length) {
      rail.addEventListener('scroll', () => {
        const i = Math.round(Math.abs(rail.scrollLeft) / rail.clientWidth);
        const slide = rail.children[i];
        if (slide) thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === slide.dataset.mediaId));
      }, { passive: true });
    }

    if (picker) {
      picker.addEventListener('change', () => {
        const selected = $$('fieldset', picker).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
        $$('[data-option-label]', picker).forEach((el, i) => { el.textContent = selected[i] || ''; });
        const v = variants.find((x) => x.options.every((o, i) => o === selected[i]));
        const priceWrap = $('[data-price-wrap]', root);
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = T.strings.unavailable; }
          if (stickyBtn) stickyBtn.disabled = true;
          return;
        }
        idInput.value = v.id;
        if (priceWrap) {
          priceWrap.innerHTML = `<div class="price${v.compare ? ' price--sale' : ''}" data-price><span class="price__current">${v.price}</span>` +
            (v.compare ? `<s class="price__compare">${v.compare}</s>` : '') +
            (v.saving ? `<span class="badge badge--sale">${v.saving}</span>` : '') + '</div>';
        }
        if (stickyPrice) stickyPrice.innerHTML = v.price;
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
        if (stickyBtn) stickyBtn.disabled = !v.available;
        if (v.media) showMedia(v.media);
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      });
    }

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(addBtn);
    }
  });

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML; else el.remove();
    } catch (_) { el.remove(); }
  });

  /* ---------- wishlist hearts (saved in this browser) ---------- */
  const WKEY = 'alamina:wishlist';
  const readWish = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (_) { return []; } };
  const syncWish = () => { const list = readWish(); $$('[data-wishlist]').forEach((b) => b.setAttribute('aria-pressed', list.includes(b.dataset.wishlist) ? 'true' : 'false')); };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist]'); if (!b) return;
    const list = readWish(); const h = b.dataset.wishlist; const i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.push(h);
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (_) {}
    syncWish();
  window.theme.syncWishlist = syncWish;
  });
  syncWish();

  /* ---------- other scripts (e.g. third-party) can ask the drawer to refresh ---------- */
  document.addEventListener('cart:refresh', () => refreshCart(true));
})();
